package ui.search

import ConfigFile
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.flow
import model.DataRepository
import model.MerchantSummaryInformation
import org.koin.compose.koinInject
import ui.DisposableViewModel
import ui.ScopeHolderFactory

@Composable
fun searchViewModel(
    scopeHolderFactory: ScopeHolderFactory = koinInject(),
): SearchViewModel {
    val scopeHolder = remember { scopeHolderFactory.getOrCreate(SearchViewModel::class) }
    DisposableEffect(Unit) { onDispose { scopeHolder.detach() } }
    return remember { scopeHolder.attach() }
}

class SearchViewModel(
    val clientConfig: ConfigFile,
    val dataRepository: DataRepository,
) : ViewModel(), DisposableViewModel {

    private val job = SupervisorJob()
    private val viewModelScope = CoroutineScope(job + Dispatchers.Main)

    private val _searchText = MutableStateFlow("")
    val searchText = _searchText

    private fun getMerchantsNearMe(): Flow<List<MerchantSummaryInformation>?> {
        return flow { emit(dataRepository.getMerchantsNearMe()) }
    }

    val filteredMerchantList = searchText
        .combine(getMerchantsNearMe()) { searchText, listOfMerchantSummary ->
            if (searchText.isBlank()) {
                return@combine listOfMerchantSummary
            }
            listOfMerchantSummary?.filter { merchant ->
                merchant.name!!.lowercase().contains(searchText.trim().lowercase())
            }
        }

    fun onSearchTextChange(text: String) {
        _searchText.value = text
    }

    init {
        println("SearchViewModel has been created!")
    }

    override fun dispose() {
        println("SearchViewModel.dispose()")
        job.cancel()
    }
}